import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import { useTranslation } from 'react-i18next'
import CasavioLogo from './shared/CasavioLogo'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', brown: '#2C1D14', muted: '#9A7B68',
}
const serif = 'Georgia, serif'
const sans = 'Calibri, sans-serif'

export default function PublicHomeConnect({ token }) {
  const { t } = useTranslation()
  const [valid, setValid] = useState(null) // null=loading true=valid false=invalid
  const [referralCode, setReferralCode] = useState(null)

  useEffect(() => {
    if (!token) { setValid(false); return }
    supabase
      .from('home_share_tokens')
      .select('home_id, referral_code')
      .eq('token', token)
      .maybeSingle()
      .then(({ data }) => {
        if (!data) { setValid(false); return }
        setValid(true)
        setReferralCode(data.referral_code || null)
        supabase.functions.invoke('log-scan', {
          body: { token, user_agent: navigator.userAgent, referrer: document.referrer || null },
        }).catch(() => {})
      })
  }, [token])

  const signUpHref = referralCode ? `/join?ref=${encodeURIComponent(referralCode)}` : '/join'

  if (valid === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: C.bg, fontFamily: sans, color: C.muted, fontSize: 14 }}>
        Loading…
      </div>
    )
  }

  if (!valid) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: C.bg, padding: 24 }}>
        <div style={{ background: C.card, borderRadius: 20, padding: '40px 32px', maxWidth: 420, width: '100%', textAlign: 'center', border: `1px solid ${C.border}` }}>
          <div style={{ marginBottom: 24 }}>
            <CasavioLogo size={18} color={C.amber} />
          </div>
          <div style={{ fontSize: 20, fontFamily: serif, color: C.brown, marginBottom: 12, fontWeight: 700 }}>
            {t('publicConnect.invalidLink')}
          </div>
          <div style={{ fontSize: 14, color: C.muted, fontFamily: sans, marginBottom: 24, lineHeight: 1.6 }}>
            {t('publicConnect.learnMore')}
          </div>
          <a href="/join" style={{ color: C.amber, fontFamily: sans, fontSize: 14, textDecoration: 'none' }}>
            casavio.app/join →
          </a>
        </div>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: C.bg, padding: 24 }}>
      <div style={{ background: C.card, borderRadius: 20, padding: '40px 32px', maxWidth: 440, width: '100%', border: `1px solid ${C.border}`, textAlign: 'center' }}>

        <div style={{ marginBottom: 28 }}>
          <CasavioLogo size={18} color={C.amber} />
        </div>

        <div style={{ fontSize: 26, fontFamily: serif, color: C.brown, fontWeight: 700, marginBottom: 14, lineHeight: 1.3 }}>
          {t('publicConnect.foundCasavioHome')}
        </div>

        <div style={{ fontSize: 14, color: C.muted, fontFamily: sans, lineHeight: 1.7, marginBottom: 32 }}>
          {t('publicConnect.tagline')}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <a
            href={signUpHref}
            style={{
              display: 'block', padding: '14px 20px',
              background: C.amber, color: '#fff',
              borderRadius: 12, textDecoration: 'none',
              fontSize: 15, fontWeight: 700, fontFamily: serif,
            }}
          >
            {t('publicConnect.signUpCTA')}
          </a>

          <a
            href="/contractors/join"
            style={{
              display: 'block', padding: '13px 20px',
              background: 'transparent', color: C.amber,
              border: `2px solid ${C.amber}`, borderRadius: 12,
              textDecoration: 'none', fontSize: 14,
              fontWeight: 600, fontFamily: sans,
            }}
          >
            {t('publicConnect.contractorCTA')}
          </a>

          <div style={{ fontSize: 12, color: C.muted, fontFamily: sans, lineHeight: 1.5, padding: '4px 0' }}>
            {t('publicConnect.emergency')}
          </div>
        </div>

        <div style={{ marginTop: 32, fontSize: 11, color: C.muted, fontFamily: sans }}>
          {t('publicConnect.footer')} ·{' '}
          <a href="https://casavio.app" style={{ color: C.muted, textDecoration: 'none' }}>casavio.app</a>
        </div>
      </div>
    </div>
  )
}
